export default {
  whoWeAre: "Chi siamo",
  whoWeAreDescription: "Una piattaforma farmaceutica leader con oltre 40 anni di eccellenza API, partnership globali in intermedi avanzati ed expertise CRDMO in formulazioni speciali e antibiotici.",
  globalImpactExcellence: "Impatto globale ed eccellenza",
  globalImpactDescription: "Fidati da partner in tutto il mondo per fornire innovazioni significative attraverso la scienza.",
  whatWeOffer: "Cosa offriamo",
  whatWeOfferDescription: "Soluzioni farmaceutiche complete supportate da decenni di competenza e portata globale, offrendo innovazione dal laboratorio alla vita in diverse aree terapeutiche.",
  regulatoryApprovals: "Approvazioni normative",
  regulatoryApprovalsDescription: "Refex Life Sciences gestisce una rete mondiale di strutture di produzione all'avanguardia perfettamente integrate nel gruppo. Queste strutture rispettano i più alti standard di qualità internazionali con accreditamenti da:",
  regulatoryApproval1: "US FDA",
  regulatoryApproval2: "EU GMP",
  regulatoryApproval3: "EDQM",
  regulatoryApproval4: "Health Canada",
  regulatoryApproval5: "ANVISA",
  regulatoryApproval6: "PMDA",
  regulatoryApproval7: "WHO-GMP",
  noOfferingsAvailable: "Nessuna offerta disponibile. Si prega di aggiungerne alcune nel pannello di amministrazione.",
};

